import { SetStateAction, useCallback } from 'react'
import PermissionChecker from '../../../../baseComponents/PermissionChecker'
import CustomSelect from '../../../../forms/CustomSelect'
import { TwinDictionary, addDictionaryExtraLine } from '../../../../utils/globals/dictionary'
import useTwinTranslation from '../../../../utils/hooks/useTwinTranslation'
import { getUserPermissions } from '../../../../utils/reducers/getters'
import { ModalCreateTaskWithHelperData } from '../types'
import { ConnectedProps, connect } from 'react-redux'
import TwinTrans from '../../../../baseComponents/TwinTrans'
import withLoading from '../../../../utils/hoc/withLoading'
import { AllReduxPayloads } from '../../../../utils/reducers'
import { CustomerPayload } from '../../../../utils/reducers/customers/customer'
import SearcherCustomerProjectSimple from '../../../Customers/SearcherCustomerProject/SearcherCustomerProjectSimple'
import CustomSelectCContactInfo from '../../../Customers/CustomerCustomSelectContactInfo'

interface TaskHelperContactPersonSelectorParentProps extends TaskHelperContactPersonSelectorProps { }

export const TaskHelperContactPersonSelectorParent: React.FC<TaskHelperContactPersonSelectorParentProps> = ({ extraProps, dataTask, setDataTask, handleOpenModalBig }) => {
    if (extraProps.CustomerContactPersonId) {
        return <TaskHelperContactPersonSelectorEdit extraProps={extraProps} dataTask={dataTask} setDataTask={setDataTask} handleOpenModalBig={handleOpenModalBig} />
    }
    return <TaskHelperContactPersonSelectorCreate extraProps={extraProps} dataTask={dataTask} setDataTask={setDataTask} handleOpenModalBig={handleOpenModalBig} />
}


interface TaskHelperContactPersonSelectorProps {
    extraProps: TwinDictionary
    dataTask: ModalCreateTaskWithHelperData
    setDataTask: React.Dispatch<SetStateAction<ModalCreateTaskWithHelperData>>
    handleOpenModalBig: (modalType: string | null) => void
}

const TaskHelperContactPersonSelectorEdit: React.FC<TaskHelperContactPersonSelectorProps> = ({ extraProps, dataTask, setDataTask, handleOpenModalBig }) => {
    const { t } = useTwinTranslation()
    const myCustomerContactPersons = addDictionaryExtraLine(JSON.parse(JSON.stringify(extraProps.customerContactPersons || {})))
    return (
        <PermissionChecker userPermissions={getUserPermissions('customer.profile.contactPerson')} permission={'update'} >
            <CustomSelectTaskContactPerson handleOpenModalBig={handleOpenModalBig} items={myCustomerContactPersons} value={dataTask?.CustomerContactPersonId} setDataTask={setDataTask} CustomerId={dataTask?.CustomerId} />
            <div className='ml-auto text-12 cursor-pointer' onClick={() => handleOpenModalBig('editContactPerson')}>{t('editContactPerson', 'Editar persona de contacto')}</div>
        </PermissionChecker>
    )
}

const TaskHelperContactPersonSelectorCreate: React.FC<TaskHelperContactPersonSelectorProps> = ({ extraProps, dataTask, setDataTask, handleOpenModalBig }) => {
    const { t } = useTwinTranslation()
    const myCustomerContactPersons = addDictionaryExtraLine(JSON.parse(JSON.stringify(extraProps.customerContactPersons || {})))
    return (
        <PermissionChecker userPermissions={getUserPermissions('customer.profile.contactPerson')} permission={'create'} >
            <CustomSelectTaskContactPerson handleOpenModalBig={handleOpenModalBig} items={myCustomerContactPersons} value={dataTask?.CustomerContactPersonId} setDataTask={setDataTask} CustomerId={dataTask?.CustomerId} />
            {extraProps.customerProjectId ?
                <div className='ml-auto text-12 cursor-pointer' onClick={() => handleOpenModalBig('newContactPerson')}>{t('addNewContactPerson', 'Añadir nueva persona de contacto')}</div>
                : null}
        </PermissionChecker>
    )
}

interface CustomSelectTaskContactPersonProps extends CustomSelectTaskContactPersonLogicProps {
    items: TwinDictionary
    CustomerId?: string
    value?: number
}

const CustomSelectTaskContactPerson: React.FC<CustomSelectTaskContactPersonProps> = ({ items, setDataTask, CustomerId, value, handleOpenModalBig }) => {
    const { t } = useTwinTranslation()
    const selectedInfo = value ? items?.[value] : undefined
    const {handleOnChange } = useCustomSelectTaskContactPersonLogic({handleOpenModalBig, setDataTask})

    if (!CustomerId) {
        return <CustomSelect readOnly={true} value={value} label={t('customerContactPersonSelectProject', 'Contacto del cliente - Selecciona proyecto')} items={{}} />
    }
    return <CustomSelectCContactInfo id={'taskHelperContactPerson'} label={t('customerContactPerson', 'Contacto del cliente')} items={items} value={value} selectedContact={selectedInfo} onChange={handleOnChange} name='CustomerContactPersonId' />
}

interface CustomSelectTaskContactPersonLogicProps {
    handleOpenModalBig: (modalType: string | null) => void
    setDataTask: React.Dispatch<SetStateAction<ModalCreateTaskWithHelperData>>
}

const useCustomSelectTaskContactPersonLogic = ({ handleOpenModalBig, setDataTask }: CustomSelectTaskContactPersonLogicProps) => {
    const handleOnChange = useCallback(async (value: any) => {
        handleOpenModalBig(null)
        setDataTask((old) => { return { ...old, CustomerContactPersonId: value } })
    }, [handleOpenModalBig, setDataTask])

    return { handleOnChange}
}


interface TaskHelperCustomerShopSelectorParentProps extends TaskHelperCustomerShopSelectorProps { }

export const TaskHelperCustomerShopSelectorParent: React.FC<TaskHelperCustomerShopSelectorParentProps> = ({ extraProps, dataTask, setDataTask, handleOpenModalBig }) => {
    if (extraProps.CustomerShopId) {
        return <TaskHelperCustomerShopSelectorEdit extraProps={extraProps} dataTask={dataTask} setDataTask={setDataTask} handleOpenModalBig={handleOpenModalBig} />
    }
    return <TaskHelperCustomerShopSelectorCreate extraProps={extraProps} dataTask={dataTask} setDataTask={setDataTask} handleOpenModalBig={handleOpenModalBig} />
}


interface TaskHelperCustomerShopSelectorProps {
    extraProps: TwinDictionary
    dataTask: ModalCreateTaskWithHelperData
    setDataTask: React.Dispatch<SetStateAction<ModalCreateTaskWithHelperData>>
    handleOpenModalBig: (modalType: string | null) => void
}

const TaskHelperCustomerShopSelectorCreate: React.FC<TaskHelperCustomerShopSelectorProps> = ({ extraProps, dataTask, setDataTask, handleOpenModalBig }) => {
    const { t } = useTwinTranslation()
    const myCustomerShops = addDictionaryExtraLine(JSON.parse(JSON.stringify(extraProps.customerShops || {})))
    return (
        <PermissionChecker userPermissions={getUserPermissions('customer.profile.shops')} permission={'create'} >
            <CustomSelectTaskCustomerShop handleOpenModalBig={handleOpenModalBig} items={myCustomerShops} value={dataTask?.CustomerShopId} setDataTask={setDataTask} CustomerId={dataTask?.CustomerId} />
            {extraProps.customerProjectId ?
                <div className='ml-auto text-12 cursor-pointer' onClick={() => handleOpenModalBig('newWorkingCenter')}>{t('addNewWorkingCenter', 'Añadir centro de trabajo')}</div>
                : null}
        </PermissionChecker>
    )
}

const TaskHelperCustomerShopSelectorEdit: React.FC<TaskHelperCustomerShopSelectorProps> = ({ extraProps, dataTask, setDataTask, handleOpenModalBig }) => {
    const { t } = useTwinTranslation()
    const myCustomerShops = addDictionaryExtraLine(JSON.parse(JSON.stringify(extraProps.customerShops || {})))
    return (
        <PermissionChecker userPermissions={getUserPermissions('customer.profile.shops')} permission={'update'} >
            <CustomSelectTaskCustomerShop handleOpenModalBig={handleOpenModalBig} items={myCustomerShops} value={dataTask?.CustomerShopId} setDataTask={setDataTask} CustomerId={dataTask?.CustomerId} />
            <div className='ml-auto text-12 cursor-pointer' onClick={() => handleOpenModalBig('editWorkingCenter')}>{t('editWorkingCenter', 'Editar centro de trabajo')}</div>
        </PermissionChecker>
    )
}

interface CustomSelectTaskCustomerShopProps extends CustomSelectTaskCustomerShopLogicProps {
    items: TwinDictionary
    CustomerId?: string
    value?: number
}

const CustomSelectTaskCustomerShop: React.FC<CustomSelectTaskCustomerShopProps> = ({ items, setDataTask, CustomerId, value, handleOpenModalBig }) => {
    const { t } = useTwinTranslation()
    const selectedInfo = value ? items?.[value] : undefined
    const { handleOnChangeCustomerShop } = useCustomSelectTaskCustomerShopLogic({handleOpenModalBig, setDataTask})

    if (!CustomerId) {
        return <CustomSelect readOnly={true} value={value} label={t('customerWorkingCenterSelectProject', 'Centro del cliente - Selecciona proyecto')} items={{}} />
    }
    return <CustomSelectCContactInfo id={'taskHelperWorkingCenter'} label={t('customerWorkingCenter', 'Centro del cliente')} items={items} value={value} selectedContact={selectedInfo} onChange={handleOnChangeCustomerShop} name='CustomerShopId'/>
}

interface CustomSelectTaskCustomerShopLogicProps {
    setDataTask: React.Dispatch<SetStateAction<ModalCreateTaskWithHelperData>>
    handleOpenModalBig: (modalType: string | null) => void
}

const useCustomSelectTaskCustomerShopLogic = ({ handleOpenModalBig, setDataTask}: CustomSelectTaskCustomerShopLogicProps) => {
    const handleOnChangeCustomerShop = useCallback(async (value: any) => {
        handleOpenModalBig(null)
        setDataTask((old) => { return { ...old, CustomerShopId: value } })
    }, [handleOpenModalBig, setDataTask])

    return { handleOnChangeCustomerShop }
}


interface TaskHelperCustomerProjectSelectorParentProps {
    extraProps: TwinDictionary
    handleAddCustomerProject: (CustomerProjectId: number | null) => Promise<boolean>
    handleOpenModalBig: (modalType: string) => void
    setLockOnClickOut?: (lock: boolean) => void
}

export const TaskHelperCustomerProjectSelectorParent: React.FC<TaskHelperCustomerProjectSelectorParentProps> = ({ extraProps, handleAddCustomerProject, handleOpenModalBig, setLockOnClickOut }) => {
    return (
        <PermissionChecker userPermissions={getUserPermissions('customer.profile.main')} permission={'read'} >
            <CustomerSearcherTaskConnect handleAddCustomerProject={handleAddCustomerProject} CustomerId={extraProps.customerId} CustomerProjectId={extraProps.customerProjectId} setLockOnClickOut={setLockOnClickOut} />
            {extraProps.customerProjectId ?
                <div className='ml-auto text-12 cursor-pointer' onClick={() => handleOpenModalBig('customerTask')}><TwinTrans transKey='customerTask'>Ver tareas del cliente</TwinTrans></div>
                : null}
        </PermissionChecker>)
}

interface CustomerSearcherTaskProps extends ReduxCustomer {
    handleAddCustomerProject: (CustomerProjectId: number | null) => Promise<boolean>
    CustomerId: number
    CustomerProjectId: number
    setLockOnClickOut?: (lock: boolean) => void
}

export const CustomerSearcherTask: React.FC<CustomerSearcherTaskProps> = ({ customers, handleAddCustomerProject, CustomerId, CustomerProjectId, setLockOnClickOut }) => {
    const { t } = useTwinTranslation()
    return (
        <SearcherCustomerProjectSimple name='CustomerProjectId' customers={customers} handleAddCustomerProject={handleAddCustomerProject} label={t('project', 'Proyecto')} CustomerId={CustomerId} CustomerProjectId={CustomerProjectId} setLockOnClickOut={setLockOnClickOut} />
    )
}

const customersDispatch = {
    setCustomers: (payload: CustomerPayload) => ({ type: 'CHANGE_CUSTOMER', payload }),
}

type ReduxCustomer = ConnectedProps<typeof customersConnect>
const mapCustomersConnector = (state: AllReduxPayloads) => ({ customers: state.customers })
const customersConnect = connect(mapCustomersConnector, customersDispatch)

const customersConnectLoading = withLoading(CustomerSearcherTask, [{ fetchUrl: '/api/app/customer/getAllCustomersComplete', propName: 'customers', setFunctionName: 'setCustomers' }])

const CustomerSearcherTaskConnect = customersConnect(customersConnectLoading)